<app-lector-manual *ngIf="isTeacher"></app-lector-manual>
<app-student-manual *ngIf="isStudent"></app-student-manual>
